import config from './config.js'
import UploadList from './upload_list/upload-list'
import VUEUpLoad from './upload_vue/upload-config'
import uploadDrop from './upload_vue/upload-drop'
import initVue from './upload_vue/index.js'
import initSWF from './upload_swf/index.js'

let uploadSingle

class Upload {
  constructor (options) {
    if (options.single && uploadSingle) {
      return uploadSingle
    }
    this.options = Object.assign(config, options)
    let _instance = this.init(this.options)
    if (!_instance) {
      throw new Error('create Vue or SWF instance failed!')
    }
    if (this.options.single) uploadSingle = _instance
    /* eslint-disable no-new */
    if (this.options.showFileList) {
      new UploadList(
        _instance.$children ? _instance.$children[0] : _instance,
        this.options
      )
    }
    Upload.defaults.language = options.language
    return _instance
  }

  /**
   * 上传组件初始化
   * @description 判断环境是否支持H5，支持返回Vue实例，否则返回SWF实例
   * Upload.defaults.swf_mode 如果为true 则强制使用SWF模式 用于调试
   * @param options
   * @returns {VUE or SWF}
   */

  init (options) {
    if (this.isSupportHTML5() && !Upload.defaults.swf_mode) {
      let v = initVue(options)
      if (options.drop) {
        uploadDrop(options, function (err, e, fs) {
          if (!err) {
            e.target.files = fs
            let uploadBtn = document.getElementById('CanUploadButton')
            if (uploadBtn && uploadBtn.getAttribute('canupload') === 'true') {
              v.$children[0].handleChange(e)
            } else {
              let words = options.language === 'en' ? 'No current operating rights' : '无当前操作权限！'
              window.Tips.show(words)
            }
          } else if (err.file) {
            options.file_queue_error_handler(
              err.file,
              VUEUpLoad.QUEUE_ERROR.DROP_DIRECTORY,
              err.message
            )
            console.error(err.message)
          } else {
            throw err
          }
        })
      }
      return v
    } else {
      return initSWF(options)
    }
  }

  /**
   * 判断当前环境是否支持H5
   * @returns {boolean}
   */

  isSupportHTML5 () {
    try {
      if (typeof FileReader === 'undefined') return false
      if (typeof Blob === 'undefined') return false
      let blob = new Blob()
      if (!blob.slice && !blob.webkitSlice) return false
      if (!('draggable' in document.createElement('span'))) return false
      if (navigator.appName === 'Microsoft Internet Explorer' && navigator.appVersion.match(/9./i) === '9.') return false
      if (location.href.indexOf('/link/view') > -1 && navigator.userAgent.indexOf('Trident') > -1 && navigator.userAgent.indexOf('rv:11.0') > -1) return false
    } catch (e) {
      return false
    }
    return true
  }
}

Upload.defaults = {
  swf_mode: false, // 强制使用SWF
  language: 'zh'
}

export default Upload



// WEBPACK FOOTER //
// ./src/components/upload/upload.js